import React, { useState } from 'react';
import api from '../api';
import './ContactButton.css';

export default function ContactButton({ settings = {} }) {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name: '', email: '', phone: '', message: '' });
  const [status, setStatus] = useState('');
  const [sending, setSending] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await api.post('/contact', form);
      setStatus('success');
      setForm({ name: '', email: '', phone: '', message: '' });
    } catch { setStatus('error'); }
    setSending(false);
  };

  return (
    <>
      <button className="contact-fab" onClick={() => setOpen(true)} aria-label="Contact us">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/></svg>
        <span>Contact</span>
      </button>

      {open && (
        <div className="contact-overlay" onClick={(e) => e.target === e.currentTarget && setOpen(false)}>
          <div className="contact-panel">
            <button className="contact-close" onClick={() => setOpen(false)}>✕</button>
            <div className="contact-header">
              <p className="tag">Get in touch</p>
              <h2>Contact Us</h2>
              <div className="divider" />
            </div>
            <div className="contact-info">
              <a href={`mailto:${settings.contact_email || 'info@elevennorth.com'}`} className="contact-info-item">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
                {settings.contact_email || 'info@elevennorth.com'}
              </a>
              <a href={`tel:${settings.contact_phone || ''}`} className="contact-info-item">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.8 19.79 19.79 0 013 1.22 2 2 0 015 .01h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L9.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 14.92z"/></svg>
                {settings.contact_phone || '+44 20 0000 0000'}
              </a>
            </div>
            <div className="contact-divider" />
            {status === 'success' ? (
              <div className="alert alert-success">Message sent! We'll be in touch shortly.</div>
            ) : (
              <form onSubmit={submit}>
                {status === 'error' && <div className="alert alert-error">Something went wrong. Please try again.</div>}
                <div className="form-group"><label>Name</label><input required value={form.name} onChange={e => setForm({...form, name: e.target.value})} placeholder="Your name" /></div>
                <div className="form-group"><label>Email</label><input required type="email" value={form.email} onChange={e => setForm({...form, email: e.target.value})} placeholder="your@email.com" /></div>
                <div className="form-group"><label>Phone <span style={{fontWeight:300,textTransform:'none',letterSpacing:0}}>(optional)</span></label><input value={form.phone} onChange={e => setForm({...form, phone: e.target.value})} placeholder="+44..." /></div>
                <div className="form-group"><label>Message</label><textarea required rows={4} value={form.message} onChange={e => setForm({...form, message: e.target.value})} placeholder="How can we help?" /></div>
                <button type="submit" className="btn-primary" style={{width:'100%',justifyContent:'center'}} disabled={sending}>
                  {sending ? 'Sending...' : 'Send Message'}
                </button>
              </form>
            )}
          </div>
        </div>
      )}
    </>
  );
}
